module.exports = __webpack_public_path__ + "assets/img/inndot.23382e28.png";